import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll to the top on every route change. React Router (`<BrowserRouter>`)
 * keeps the previous scroll position across navigations by default, so switching
 * pages would otherwise land mid-page. Scrolls the window and, defensively, any
 * scrollable layout container. Runs on pathname change only (not on query/hash
 * changes, so in-page tab switches don't jump).
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll('.v2-dashboard-layout__content, .v2-dashboard-layout__main').forEach(
      (element) => {
        if (element instanceof HTMLElement) element.scrollTop = 0;
      },
    );
  }, [pathname]);

  return null;
};

export default ScrollToTop;
